import Vue from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import gigJobPartiesMixin from './gigJobPartiesMixin'
import waitForRefreshApplicationMixin from './waitForRefreshApplicationMixin'
import { getGigOffer } from '@/api/gigs/offers/offers'
import { getJob } from '@/api/jobs/job/job'
import { GigJobStages } from '@/constants/gig/gigJobStages'
import { STAGE_IN_PROGRESS } from '@/constants/job/jobStages'
import snackMixin from '@/mixins/snackMixin'
import GigOfferListItem from '@/models-ts/gigs/GigOfferListItem'
import Job from '@/models-ts/job/Job'
import { RootState } from '@/store'
import { addDays, addSeconds, convertToLocal, isBefore } from '@/utils/date'

const EXTRA_DAYS = 2

export default Vue.extend({
  mixins: [gigJobPartiesMixin, snackMixin, waitForRefreshApplicationMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.gigChat.application.value,
      returnFundsToCustomerLoading: (state: RootState) => state.gig.returnFundsToCustomerLoading,
    }),
    deadline() {
      return addSeconds(convertToLocal(this.application?.job?.created_at), this.application.offer?.deadline)
    },
    refundDate() {
      return addDays(this.deadline, EXTRA_DAYS)
    },
    refundHasCome() {
      return isBefore(this.refundDate, Date.now())
    },
    hasRefund() {
      return this.isEmployer && this.application?.job?.stage === GigJobStages.IN_PROGRESS && this.refundHasCome
    },
    refunding() {
      return this.returnFundsToCustomerLoading[this.application?.job?.id]
    },
  },
  methods: {
    ...mapMutations({
      setReturnFundsToCustomerLoading: 'gig/setReturnFundsToCustomerLoading',
    }),
    ...mapActions({
      runRefund: 'gig/refundToCustomerByCustomerV2',
    }),
    async refundToCustomer() {
      this.setReturnFundsToCustomerLoading({ gigId: this.application?.job?.id })

      let offer
      try {
        offer = GigOfferListItem.fromServer(await getGigOffer(this.application.offer.id))
        if (!offer) return
      } catch (error) {
        this.openSnackbar({
          type: this.SnackTypes.FAILURE,
          text: `Error fetching offer details. Please try again.`,
        })
        this.setReturnFundsToCustomerLoading({ jobId: this.application?.job?.id, loading: false })
        throw error
      }

      if (process.env.VUE_APP_MODE === 'dev') {
        this.runRefund({
          gig: offer,
          successSign: this.waitRefreshApplication,
        })
      } else {
        if (this.refundHasCome) {
          this.runRefund({
            gig: offer,
            successSign: this.waitRefreshApplication,
          })
        } else {
          this.openSnackbar({
            type: this.SnackTypes.FAILURE,
            text: `You can only initiate a refund 48 hours after the deadline has been reached.`,
          })
        }
      }
    },
  },
})
